import { Component, inject, input, output, afterRenderEffect, ChangeDetectionStrategy, untracked } from '@angular/core';
import { FormGroup, FormControl, Validators, ReactiveFormsModule } from '@angular/forms';
import { first } from 'rxjs/operators';
import { IProfile, ProfileService } from '../profile.service';
import { AuthService } from '../../../auth.service';
import { MatSlideToggleModule } from '@angular/material/slide-toggle'
import { MatDivider } from '@angular/material/divider';
import { MatButton } from '@angular/material/button';
import { PaintDirective } from '../../../paint.directive';
import { RouterLink } from '@angular/router';
import { LocationService } from '../../../location.service';

@Component({
  selector: 'profile-preferences',
  templateUrl: 'preferences.component.html',
  styleUrls: ['preferences.component.scss'],
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [MatSlideToggleModule, ReactiveFormsModule, MatDivider, MatButton, PaintDirective, RouterLink]
})
export class ProfilePreferencesComponent {
  service = inject(ProfileService);

  form: FormGroup = new FormGroup({
    optin_email: new FormControl(false, [Validators.required]),
    optin_sms: new FormControl(false, [Validators.required]),
    optin_push: new FormControl(false, [Validators.required]),
    optin_email_remarketing: new FormControl(false, [Validators.required]),
    optin_sms_remarketing: new FormControl(false, [Validators.required]),
    optin_push_remarketing: new FormControl(false, [Validators.required]),
  });

  constructor() { 
    afterRenderEffect(() => {
      const preferences = this.service.profile();

      untracked(() => { 
        if(preferences){
          this.form.reset(preferences);
        } 
      })
    });
  }

  countSame(): number {
    return Object.keys(this.formChanges()).length;
  }

  formChanges(): Partial<IProfile> {
    return Object.fromEntries(Object.entries(this.form.controls).filter(([key,control]) => control.dirty).map(([key,control]) => ([key,control.value])));
  }

  submit(callback?: Function){
    if(this.form.valid) {
      const updatedUser = this.formChanges();

      if(!Object.keys(updatedUser).length){
        this.service.toast.info('No changes have been made');
        return;
      }

      this.service.loading.set(true);

      this.service.editProfile(updatedUser).pipe(first()).subscribe({
        next: res => {

          this.service.profile.update(user => {
            const mergedUser = Object.assign(Object.assign({}, user), updatedUser) as IProfile;
            return mergedUser;
          });

          if (callback) {
            callback();
          }

          this.service.loading.set(false);

          this.service.toast.info('Your preferences have been updated!');
        },
        error: error => {
          error = error.error || error;
          if (error.code == 3) {
            this.service.toast.error('Account deactivated or deleted');
            this.service.router.navigate(['/logout'], { queryParams: { reason: 'Account deactivated or deleted' } });
          }
          else{
            this.service.toast.error(error.message);
          }
          this.service.loading.set(false);
        }
      });
    }
    else
    {
      this.form.markAllAsTouched();
      this.service.toast.error('Not all fields are valid');
    }
  }

}
